<div class="astral-time-duration" [class.astral-time-duration--readonly]="isReadonly">
  <label class="astral-time-duration__part">
    <span class="astral-time-duration__label">{{ 'TIME.HOURS' | translate }}</span>
    <input type="number" min="0" class="astral-time-duration__control" [attr.aria-label]="'TIME.HOURS' | translate" [(ngModel)]="hours" (input)="onTimeChange()" [disabled]="isReadonly" />
  </label>
  <span class="astral-time-duration__divider" aria-hidden="true">:</span>
  <label class="astral-time-duration__part">
    <span class="astral-time-duration__label">{{ 'TIME.MINUTES' | translate }}</span>
    <input type="number" min="0" max="59" class="astral-time-duration__control" [attr.aria-label]="'TIME.MINUTES' | translate" [(ngModel)]="minutes" (input)="onTimeChange()" [disabled]="isReadonly" />
  </label>
</div>
